import * as React from 'react'
import './StatisticsBar.scss'

interface IStatisticsBarProps {
  children: any
}

export class StatisticsBar extends React.PureComponent<IStatisticsBarProps> {
  render() {
    const { children } = this.props
    return <section className="statistics-bar">{children}</section>
  }
}
